import homeHero from "./home_hero.png";
import homeCards from "./home_cards.png";
import feature from "./feature.png";
import scene from "./scene.png";
import heroPeople from "./hero-people.png";
import heroPeople2 from "./hero-people-2.png";

// Ensure all paths are absolute (starting with /)
// This prevents issues with relative paths when deployed to subdirectories
function ensureAbsolutePath(path: string | { default?: string }): string {
  // Handle webpack module exports (could be string or object with default)
  const pathStr = typeof path === 'string' ? path : (path?.default || String(path));
  
  // If it's already absolute (starts with /) or is a full URL, return as-is
  if (pathStr.startsWith('/') || pathStr.startsWith('http://') || pathStr.startsWith('https://')) {
    return pathStr;
  }
  // Make it absolute by adding leading slash
  return '/' + pathStr;
}

const assets = {
  homeHero: ensureAbsolutePath(homeHero),
  homeCards: ensureAbsolutePath(homeCards),
  feature: ensureAbsolutePath(feature),
  scene: ensureAbsolutePath(scene),
  heroPeople: ensureAbsolutePath(heroPeople),
  heroPeople2: ensureAbsolutePath(heroPeople2),
};

export default assets;
